import { Project } from '@/model/Project'
import { Multimedia } from '@/model/Multimedia'
import { Category } from '@/model/Category'

export default {
  prepareDataToApi(project: Project): Project {
    const dataToApi: Project = Object.assign({}, project)

    dataToApi.mainImage = (dataToApi.mainImage as Multimedia)['@id']

    const imageIris = []
    for (let i = 0; i < dataToApi.multimedia.length; i++) {
      imageIris.push((dataToApi.multimedia[i] as Multimedia)['@id'])
    }
    dataToApi.multimedia = imageIris;

    const categoriesIris = [];
    for (let i = 0; i < dataToApi.categories.length; i++) {
      categoriesIris.push((dataToApi.categories[i] as Category)['@id'])
    }
    dataToApi.categories = categoriesIris;

    return dataToApi
  },
}
